import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SELECT } from 'common/constants';
import { DisbursementsJournalDropdown } from 'components';
import { DropdownOption } from 'components/Dropdown/types';
import { createJournalDropdown, findDefaultJournalOption } from './helpers';
import { Journals } from './types';

export const CashDisbursementsJournal = ({
  disbursementJournals,
  isLoading,
  selectedCashCompany,
  setSelectedJournal
}: {
  disbursementJournals: Journals[] | undefined;
  isLoading: boolean;
  selectedCashCompany: DropdownOption | undefined;
  setSelectedJournal: (option: DropdownOption) => void;
}): React.JSX.Element => {
  const intl = useIntl();
  const [defaultOption, setDefaultOption] = useState<
    DropdownOption | undefined
  >(undefined);

  const dropdownOptions = createJournalDropdown(disbursementJournals);

  useEffect(() => {
    if (
      !defaultOption &&
      selectedCashCompany &&
      selectedCashCompany?.value !== SELECT &&
      disbursementJournals &&
      disbursementJournals?.length > 0
    ) {
      setDefaultOption(
        findDefaultJournalOption(
          selectedCashCompany?.value ?? '',
          disbursementJournals,
          intl
        )
      );
    }
  }, [defaultOption, disbursementJournals, intl, selectedCashCompany]);

  return (
    <DisbursementsJournalDropdown
      disbursementJournals={dropdownOptions || []}
      setSelectedJournal={setSelectedJournal}
      isLoading={isLoading}
      defaultOption={defaultOption}
    />
  );
};
